export default "<app-text [prodId]=\"'contactuspagetitle'\"></app-text>\n<app-contact-us></app-contact-us>\n<app-footer></app-footer>"